import { render, staticRenderFns } from "./listFeedback.vue?vue&type=template&id=77970bf9&scoped=true&"
import script from "./listFeedback.vue?vue&type=script&lang=js&"
export * from "./listFeedback.vue?vue&type=script&lang=js&"
import style0 from "./listFeedback.vue?vue&type=style&index=0&id=77970bf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77970bf9",
  null
  
)

export default component.exports